import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import StudentRightsCheck from "./StudentRightsCheck";
import imgExamination from "../../assets/images/icons/exam.svg";

function ExamResultsComingSoon() {
  useEffect(() => {
    document.title = "Exam Results - Student Panel";
  }, []);

  return (
    <>
      <StudentRightsCheck />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/student-panel/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Exam Results
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Exam Results</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container body-content">
        <div className="card">
          <div className="card-body text-center py-5">
            <img
              src={imgExamination}
              alt="Exam Results"
              className="mb-3"
              style={{ maxWidth: "80px", opacity: 0.8 }}
            />
            <h5 className="mb-2">Exam Results</h5>
            <p className="text-muted mb-0">This feature is coming soon. You will be able to view your exam results here.</p>
            <Link to="/student-panel/dashboard" className="btn btn-primary mt-3">
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExamResultsComingSoon;
